export function parseProductQuantity(raw: string, max?: number) {
  if (raw === "") return;
  const next = Number(raw);
  if (!Number.isFinite(next)) return;
  const nextValue = Math.max(1, Math.floor(next));
  return typeof max === "number" ? Math.min(max, nextValue) : nextValue;
}
